<script>
  export default{
    name : 'PersonIcon'
  }
</script>
<template>
  <path d="M36.2,33.8C36.2,26.2,42.4,20,50,20s13.8,6.2,13.8,13.8S57.6,47.5,50,47.5S36.2,41.3,36.2,33.8z M72.6,73.7  c-0.2-11.8-9.7-21.5-21.5-22.1c-6.2-0.3-12.2,1.9-16.7,6.2c-4.5,4.3-7,10.1-7,16.4c0,3.2,2.7,5.8,5.9,5.8h33.4  c1.6,0,3.1-0.6,4.2-1.7c1.1-1.1,1.7-2.6,1.7-4.1v0v0L72.6,73.7z"/>
</template>
